<template>
  <v-container fluid fill-height class="ob-container">
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card class="ob-login ob-rounded-corners elevation-10">
          <v-card-title>
            <v-layout column>
              <v-flex d-flex>
                <v-spacer></v-spacer>
                <v-btn icon color="error" flat style="flex: 0 0 auto !important" @click="emitEvent('close-login')">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-flex>
              <v-flex d-flex>
                <v-spacer></v-spacer>
                <h2 class="text-xs-center accent--text text--darken-2 display-1 font-weight-light" v-html="translateUI('Login_1', lang)">
                </h2>
                <v-spacer></v-spacer>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-divider class="mt-4 mb-4"></v-divider>
          <v-card-text>
            <v-form>
              <v-layout justify-center column>
                <v-flex xs8 class="mb-4">
                  <v-text-field
                    type="email"
                    prepend-icon="mdi-account-circle"
                    solo
                    hide-details
                    flat
                    class="ob-textfield ob-rounded-corners pl-3 pr-3"
                    :placeholder="translateUI('Login_2', lang)"
                    v-model="email"
                    @keyup.enter="login">
                  </v-text-field>
                </v-flex>
                <v-flex xs8 class="mb-4">
                  <v-text-field
                    :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPass = !showPass"
                    :type="showPass ? 'text' : 'password'"
                    prepend-icon="mdi-lock"
                    solo
                    hide-details
                    flat
                    class="ob-textfield ob-rounded-corners pl-3 pr-3"
                    :placeholder="translateUI('Login_3', lang)"
                    v-model="password"
                    @keyup.enter="login">
                  </v-text-field>
                </v-flex>
                <v-flex xs8 class="mb-4" v-if="error">
                  <v-alert :value="!!error" type="error" v-html="translateUI('Login_4', lang)">
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-form>
            <div class="text-xs-center">
              <v-btn color="accent" large :disabled="!email || !password" @click="login">
                <v-icon>mdi-login-variant</v-icon>
              </v-btn>
            </div>
            <v-layout align-center column class="mt-5">
              <!-- <v-flex xs12 class="mb-0" style="display: none">
                <a class="ma-0 primary--text text--lighten-2 ob-login-links" @click="emitEvent('show-inregistrare')">
                  <v-icon small class="primary--text text--lighten-2 mr-1">mdi-account-plus</v-icon>
                  Creeaza un cont nou
                </a>
              </v-flex> -->
              <v-flex xs12 class="mb-0">
                <a href="mailto:analiza@tudconsult.ro" target="_blank" class="ma-0 secondary--text text--lighten-1 ob-login-links">
                  <v-icon small class="secondary--text text--lighten-1 mr-1">mdi-email</v-icon>
                  Contact
                </a>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import translate from '@/mixins/Translate'

export default {
  name: 'login',
  mixins: [translate],
  data: () => ({
    email: '',
    password: '',
    error: null,
    showPass: false
  }),
  computed: {
    lang () {
      return this.$store.getters['dictionar/lang']
    }
  },
  methods: {
    emitEvent (event) {
      this.$emit(event)
    },
    login () {
      if (this.email && this.password) {
        this.error = null
        this.$store.dispatch('login', { email: this.email.trim(), password: this.password.trim() })
          .then(result => {
            const user = this.$store.getters.user
            if (user) {
              this.error = null
              this.email = null
              this.password = null
              if (user.admin) this.$router.push({ name: 'users' })
              else this.$router.push({ name: 'municipii-client' })
            } else {
              this.error = 'Combinatie incorecta de email/parola...'
            }
          }).catch(error => {
            console.log(error)
            this.error = 'Combinatie incorecta de email/parola...'
          })
      }
    }
  }
}
</script>
